import { useFilterDisabledSettings } from "@api";
import type { ISettingValue } from "@bbj-types/setting";
import type { Override } from "@bbj-types/utils";
import { FormControl, InputLabel, MenuItem, Select, type SelectProps } from "@mui/material";

interface ISettingSelect extends Override<SelectProps<string>, { id: string; label: string }> {
  setting: ISettingValue[];
}

export const InputSetting = ({ id, label, value, onChange, setting, error, ...props }: ISettingSelect) => {
  const filteredSetting = useFilterDisabledSettings(setting, value);

  return (
    <FormControl fullWidth error={error}>
      <InputLabel id={`${id}-label`} size="small">
        {label}
      </InputLabel>
      <Select id={id} labelId={`${id}-label`} label={label} value={value} onChange={onChange} size="small" {...props}>
        {filteredSetting.map((setting) => (
          <MenuItem key={setting.value} value={setting.value}>
            {setting.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
